@let blok = block();
<div [innerHtml]="renderedContent()"></div>
<cite class="block break-words my-3 text-base">{{ blok.author }}</cite>
